import { useState } from "react";

/**
 * Round "scoop" visual for a flavor.
 * - If `img` is provided, the PNG is shown (transparent background expected).
 * - Otherwise, a radial gradient sphere is drawn from `colors` [highlight, deep].
 */
export default function ScoopBall({ img, alt, colors, size = "large" }) {
    const [imgOk, setImgOk] = useState(Boolean(img));
    const sizeClass = size === "small" ? "w-20 h-20" : "w-32 h-32 sm:w-36 sm:h-36";

    if (img && imgOk) {
        return (
            <div className={`${sizeClass} relative`}>
                <img
                    src={img}
                    alt={alt}
                    onError={() => setImgOk(false)}
                    className="w-full h-full object-contain drop-shadow-[0_10px_18px_rgba(36,85,99,0.18)]"
                />
            </div>
        );
    }

    const [hi, lo] = colors || ["#F2EAC7", "#C9A878"];
    return (
        <div
            className={`${sizeClass} rounded-full shadow-[0_12px_24px_-8px_rgba(36,85,99,0.25)]`}
            style={{
                background: `radial-gradient(circle at 32% 30%, ${hi} 0%, ${hi} 18%, ${lo} 82%, ${lo} 100%)`,
            }}
            aria-label={alt}
            role="img"
        />
    );
}
